'use client';

export function applyTheme(theme: 'dark' | 'light' | 'system'): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  let resolved = theme;
  if (theme === 'system') {
    resolved = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  root.setAttribute('data-theme', resolved);
}

export function applyAccentColor(hex: string): void {
  if (typeof document === 'undefined') return;
  document.documentElement.style.setProperty('--accent', hex);
  // derive dim version (darken by ~30%)
  const dim = darkenHex(hex, 0.3);
  document.documentElement.style.setProperty('--accent-dim', dim);
  document.documentElement.style.setProperty('--accent-glow', hexToRgba(hex, 0.15));
  document.documentElement.style.setProperty('--accent-border', hexToRgba(hex, 0.3));
  document.documentElement.style.setProperty('--text-accent', hex);
}

function darkenHex(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.max(0, (num >> 16) - Math.round(255 * amount));
  const g = Math.max(0, ((num >> 8) & 0xff) - Math.round(255 * amount));
  const b = Math.max(0, (num & 0xff) - Math.round(255 * amount));
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

function hexToRgba(hex: string, alpha: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = (num >> 16) & 0xff;
  const g = (num >> 8) & 0xff;
  const b = num & 0xff;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}